import ScalarIconLegacyAdapter_vue_vue_type_script_setup_true_lang_default from "./ScalarIconLegacyAdapter.vue.script.js";
//#region src/components/ScalarIcon/ScalarIconLegacyAdapter.vue
var ScalarIconLegacyAdapter_default = ScalarIconLegacyAdapter_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconLegacyAdapter_default as default };

//# sourceMappingURL=ScalarIconLegacyAdapter.vue.js.map